import React, {useEffect, useState} from 'react';
import {Session} from 'src/models';
import {startOfDay, endOfDay} from 'date-fns';
import {HomeSession} from 'src/modules/home/components';

const SessionTotals = ({
  totalSessions,
  sessionsCompleted,
  notesDue,
  startDate,
  endDate,
  from = '',
}: any) => {
  const [filteredSessions, setFilteredSessions] = useState<Session[]>([]);
  const [completedSessionsInRange, setCompletedSessionsInRange] = useState<
    Session[]
  >([]);
  const [notesDueInRange, setNotesDueInRange] = useState<Session[]>([]);

  useEffect(() => {
    if (!totalSessions || !sessionsCompleted || !notesDue) {
      return;
    }

    const start = startOfDay(new Date(startDate));
    const end = endOfDay(new Date(endDate));

    const isInRange = (session: Session) => {
      const sessionDate = new Date(session.date);
      return sessionDate >= start && sessionDate <= end;
    };

    const filtered = totalSessions.filter(isInRange);
    const completed = sessionsCompleted.filter(isInRange);
    const notes = notesDue.filter(isInRange);

    setFilteredSessions(filtered);
    setCompletedSessionsInRange(completed);
    setNotesDueInRange(notes);
  }, [startDate, endDate, totalSessions, sessionsCompleted, notesDue]);

  return (
    <HomeSession
      total={filteredSessions.length}
      completed={completedSessionsInRange.length}
      sessionNotesDue={notesDueInRange.length}
      role={null}
      from={from}
      cardStyle={false}
    />
  );
};

export default SessionTotals;
